import { render, staticRenderFns } from "./BgTitleBox.vue?vue&type=template&id=6220b08b&scoped=true&"
import script from "./BgTitleBox.vue?vue&type=script&lang=js&"
export * from "./BgTitleBox.vue?vue&type=script&lang=js&"
import style0 from "./BgTitleBox.vue?vue&type=style&index=0&id=6220b08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6220b08b",
  null
  
)

export default component.exports